<script setup lang="ts">
import { computed } from 'vue'
import { useDialogStore } from '@/stores/dialog'

const dialogStore = useDialogStore()

const props = defineProps<{
  modelValue: boolean
  text: string
  callback?: (() => void) | null
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const isOpen = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
    if (!val) {
      dialogStore.close()
    }
  },
})

function onConfirm() {
  if (props.callback) {
    props.callback()
  }
  dialogStore.close()
}

function onCancel() {
  dialogStore.close()
}
</script>

<template>
  <v-dialog
    v-model="isOpen"
    max-width="680"
  >
    <v-card>
      <v-card-title
        class="text-h6"
        style="word-break: break-word"
      >
        {{ text }}
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="onCancel">
          Retour
        </v-btn>
        <v-btn
          color="primary"
          @click="onConfirm"
        >
          Confirmer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
